<ng-container *ngIf="bookingStore.loaded$ | async; else loader">
  <ng-container
    *ngIf="(bookingStore.selectedPlan$ | async) !== BookingPlans.Trial; else trialConfirmation"
  >
    <div
      *ngIf="bookingStore.subscriptionsDetailsLoaded$ | async; else loader"
      class="checkout-wrapper"
    >
      <div class="back-btn-wrapper">
        <button
          *ngIf="(bookingStore.loaded$ | async) && !isSubscriptionUpdate"
          mat-stroked-button
          gtm="onSelect"
          gtmAction="Booking Stepper"
          gtmCategory="booking"
          color="primary"
          (click)="onBack()"
          data-at-back-button
        >
          {{ 'GENERAL.BUTTON.BACK' | translate }}
        </button>
      </div>
      <div class="checkout-content">
        <div class="checkout-list-wrapper" data-at-checkout-devices-summary>
          <div class="checkout-list">
            <div class="checkout-header-wrapper">
              <ng-container *ngIf="bookingStore.selectedPlan$ | async as plan">
                <h3 *ngIf="plan === BookingPlans.Plus" class="checkout-list-header">
                  {{ '+BOOKING.CHECKOUT.PLUS_LIST_DESCRIPTION' | translate }}
                </h3>
                <h3 *ngIf="plan === BookingPlans.Pro" class="checkout-list-header">
                  {{ '+BOOKING.CHECKOUT.PRO_LIST_DESCRIPTION' | translate }}
                </h3>
              </ng-container>
            </div>

            <app-booking-devices-list
              *ngIf="bookingStore.selectedDevices$ | async as selectedDevices"
            >
              <div
                *ngFor="let device of selectedDevices; let i = index"
                class="checkout-list-entry"
                installation-item
                data-at-installation
                id="installation-{{ device.installationId }}"
              >
                <span class="entry-index">{{ i + 1 }}.</span>
                <span
                  ><span class="entry-name">{{ bookingService.getDeviceTitle(device) }}</span
                  ><span class="entry-address">{{ device.location }}</span
                  ><span data-at-boiler-id class="entry-serial">{{ device.vin }}</span></span
                >
              </div>
            </app-booking-devices-list>
          </div>
        </div>
        <div class="checkout-summary-wrapper">
          <div class="summary-transfer" data-at-payment-method-section>
            <h3 class="summary-title">
              {{ '+BOOKING.CHECKOUT.PAYMENT_METHOD' | translate }}
            </h3>
            <div class="summary-transfer-content">
              <p>{{ '+BOOKING.CHECKOUT.PAYMENT_DETAILS' | translate }}</p>
            </div>
          </div>
          <app-booking-summary
            data-at-checkout-section
            (continue)="onContinue()"
            [anyInstallationSelected]="true"
            [isCheckout]="true"
          ></app-booking-summary>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #trialConfirmation>
  <div [ngSwitch]="bookingStore.purchaseTrialStatus$ | async">
    <div *ngSwitchCase="BOOKING_TRIAL_STATUS.LOADED_SUCCESS">
      <div
        data-at-trial-confirmation
        class="trial-confirmation-container flex flex-col gap-[32px] justify-center items-center"
      >
        <mat-icon class="main-icon">check_circle</mat-icon>
        <h2 data-at-thanks-for-trial>
          {{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.TITLE' | translate }}
        </h2>
        <p>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.DESCRIPTION' | translate }}</p>
        <a
          [routerLink]="[
            '/installations',
            (bookingStore.selectedDevices$ | async)[0]?.installationId
          ]"
        >
          <button
            data-at-go-to-devices-button
            gtm="onGoToPage"
            gtmAction="Installation details"
            gtmCategory="booking"
            mat-raised-button
            color="primary"
            class="go-to-installation-btn"
          >
            <span>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.BTN' | translate }}</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </a>
      </div>
    </div>
    <div *ngSwitchCase="BOOKING_TRIAL_STATUS.LOADED_ERROR">
      <div
        class="trial-confirmation-container flex flex-col gap-[32px] justify-center items-center"
        *ngIf="bookingStore.error$ | async as error"
      >
        <mat-icon class="main-icon red-icon">cancel</mat-icon>
        <h2>
          {{ '+BOOKING.CHECKOUT.ERROR.TITLE' | translate }}
        </h2>
        <p>
          {{
            '+BOOKING.CHECKOUT.ERROR.' +
              (error.extendedPayload?.errorType || error.errorType || error.type) | translate
          }}
        </p>
        <button
          gtm="onGoToPage"
          gtmAction="Booking 1st step"
          gtmCategory="booking"
          mat-raised-button
          color="primary"
          (click)="onReset()"
          class="go-to-installation-btn"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.ERROR_BTN' | translate }}</span>
        </button>
      </div>
    </div>
    <div *ngSwitchDefault [ngTemplateOutlet]="loader"></div>
  </div>
</ng-template>
<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
